const UTM_SOURCE = 'kitapcik.net';

const EXTRA_UTM_KEYS = ['utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'] as const;

/** Dış bağlantılarda yalnızca utm_source bırakır; diğer UTM parametrelerini kaldırır */
export function appendOutboundUtm(url: string | null | undefined): string | null {
  if (!url?.trim()) return null;

  const trimmed = url.trim();

  try {
    const parsed = new URL(/^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`);

    for (const key of EXTRA_UTM_KEYS) {
      parsed.searchParams.delete(key);
    }

    parsed.searchParams.set('utm_source', UTM_SOURCE);
    return parsed.toString();
  } catch {
    return trimmed;
  }
}
